import { render, staticRenderFns } from "./MargemLucro.vue?vue&type=template&id=265d3aa0&scoped=true"
import script from "./MargemLucro.vue?vue&type=script&lang=js"
export * from "./MargemLucro.vue?vue&type=script&lang=js"
import style0 from "./MargemLucro.vue?vue&type=style&index=0&id=265d3aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265d3aa0",
  null
  
)

export default component.exports